import React from "react";
import TextDisplay from "../../atoms/TextDisplay";
import ProfileIcon from "../../atoms/ProfileIcon";

const Message = ({ text, type }) => {
  const url = type === "user" ? new URL('../../../../public/blank-profile-pic.webp', import.meta.url) : new URL('../../../../public/blue_kinic.png', import.meta.url);
  return (
    <div className="w-full justify-center text-base md:gap-6 m-auto py-2 px-4 border border-gray-300 border-t-0 border-l-0 border-r-0">
      <div className="mx-auto md:max-w-3xl flex gap-3 text-base md:px-5 lg:px-1 xl:px-5">
        <ProfileIcon url={url} />
        <TextDisplay text={text} />
      </div>
    </div>
  );
};

export default Message;